import React, { useContext, useEffect, useRef, useState } from "react";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { Toast } from "primereact/toast";
import Card from "../../../../Base/Components/Card/Card";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { getAreas } from "../../../../Base/API/Global/Areas/AreasRequests";
import AreasScreen from "./Areas/AreasScreen";
import AreaCrudModal from "./Areas/AreasCrudModal";
import ClasificacionScreen from "./Clasificacion/ClasificacionScreen";
import { getClasificacionAreas } from "../../../../API/Global/Areas/ClasificacionRequest";
import ClasificacionCRUD from "./Clasificacion/ClasificacionCRUD";

const TabAreasScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [activeIndex, setActiveIndex] = useState(0);
  const [areas, setAreas] = useState("");
  const [clasificacionArea, setClasificacionArea] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showDialogCA, setShowDialogCA] = useState(false);


  const getInfo = async () => {
    setLoading(true);
    if (activeIndex === 0) {
      const a = await getAreas();
      setAreas(a);
    } else if (activeIndex === 1) {
      const ca = await getClasificacionAreas();
      setClasificacionArea(ca);
    }
    setLoading(false);
  };

  const openCrud = async () => {
    setLoading(true);
    if (activeIndex === 0) {
      setShowDialog(true);
      setSelected(null);
    } else if (activeIndex === 1) {
      setShowDialogCA(true)
      setSelected(null)
    }
    setLoading(false);
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "areas", config.language));
  }, []);

  useEffect(() => {
    getInfo();
    setSelected([])
  }, [activeIndex]);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "areas", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button icon="pi pi-plus" severity="success" onClick={openCrud} />
          </div>
        }
        contenido={
          <TabView
            style={{ marginTop: "30px" }}
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            <TabPanel header={"Areas"}>
              <div style={{ height: "82vh" }}>
                <AreasScreen
                  areas={areas}
                  selected={selected}
                  setSelected={setSelected}
                  loading={loading}
                  showDialog={showDialog}
                  setShowDialog={setShowDialog}
                  getInfo={getInfo}
                />
              </div>
            </TabPanel>

            <TabPanel header={"Clasificación"}>
              <div style={{ height: "84vh" }}>
                <ClasificacionScreen
                  data={clasificacionArea}
                  selected={selected}
                  setSelected={setSelected}
                  loading={loading}
                  showDialog={showDialogCA}
                  setShowDialog={setShowDialogCA}
                  getInfo={getInfo}
                />
              </div>
            </TabPanel>
          </TabView>
        }
      />

      {showDialog && (
        <AreaCrudModal
          toastRef={toast}
          areaDialog={showDialog}
          area={selected}
          setAreaDialog={setShowDialog}
          getArea={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}

      {showDialogCA && (
        <ClasificacionCRUD
          showDialogCA={showDialogCA}
          selected={selected}
          setShowDialogCA={setShowDialogCA}
          getInfo={getInfo}
        />
      )}
    </div>
  );
};

export default TabAreasScreen;
